module.exports = __webpack_public_path__ + "img/zain kids.56910d75.png";